import { useTranslation } from 'react-i18next';
import { Group } from '../../../api/groups';

import Pill from '@pelckmans/elementis/components/pill';
import PillGroup from '@pelckmans/elementis/components/pill-group';
import FailureIcon from '@pelckmans/elementis/icons/failure';
import PendingIcon from '@pelckmans/elementis/icons/pending';
import SuccessIcon from '@pelckmans/elementis/icons/success';

type StudentStatusPillsProps = {
  group: Group;
};

export default function StudentStatusPills({ group }: StudentStatusPillsProps): JSX.Element {
  const { t } = useTranslation();
  const pills = [];

  if (group.totalAccepted > 0) {
    pills.push(
      <Pill
        key="accepted"
        icon={<SuccessIcon data-testid="success-icon" />}
        prominence="success"
        aria-label={t('PAGES.MY_GROUPS.LIST_GROUP.STUDENTS.ACCEPTED.A11Y_LABEL', {
          amount: group.totalAccepted,
        })}
      >
        {String(group.totalAccepted)}
      </Pill>,
    );
  }

  if (group.totalPending > 0) {
    pills.push(
      <Pill
        key="pending"
        icon={<PendingIcon data-testid="pending-icon" />}
        prominence="warning"
        aria-label={t('PAGES.MY_GROUPS.LIST_GROUP.STUDENTS.PENDING.A11Y_LABEL', {
          amount: group.totalPending,
        })}
      >
        {String(group.totalPending)}
      </Pill>,
    );
  }

  if (group.totalDeclined > 0) {
    pills.push(
      <Pill
        key="declined"
        icon={<FailureIcon data-testid="failure-icon" />}
        prominence="danger"
        aria-label={t('PAGES.MY_GROUPS.LIST_GROUP.STUDENTS.DECLINED.A11Y_LABEL', {
          amount: group.totalDeclined,
        })}
      >
        {String(group.totalDeclined)}
      </Pill>,
    );
  }

  return pills.length === 0 ? (
    <></>
  ) : (
    <PillGroup role="group" aria-label={t('PAGES.MY_GROUPS.LIST_GROUP.STUDENTS.A11Y_LABEL')} size="sm">
      {pills}
    </PillGroup>
  );
}
